var themeObject = {
  name: 'default',
  theme: {
    base: {
      chart: {
        labelDisplay: 'stagger !important',
        caption: 'Theme Caption \\!important',
        canvasBgColor: '#56EF22',
        borderThickness: '5 !important',
        borderColor: '#E60539',
        baseFontColor: '#781129'
      },
      categories: [{
        fontColor: '#0F4F40',
        fontSize: 15,
        category: function category(a) {
          return {
            showLabel: a % 2 ? 0 : 1
          };
        },
        vline: {
          color: '#000000',
          thickness: 2
        }
      }],
      dataset: [{
        color: '#8C3146',
        data: function data(a, b) {
          return 8 == a && (b.value = ''), {
            color: 32e3 > +b.value ? '#8C3146' : '#FF0000',
            alpha: '100'
          };
        }
      }],
      trendlines: [{
        line: function line(a) {
          return a ? {
            color: '#ff0000',
            thickness: 3
          } : {
            color: '#ffff00',
            thickness: 3
          };
        }
      }]
    },
    pie2d: {
      chart: {
        bgColor: '#FF0000'
      }
    },
    msline: {
      chart: {
        canvasBgColor: '#ff0000'
      }
    },
    geo: {
      chart: {
        canvasBgColor: '#0000ff'
      }
    },
    world: {
      chart: {
        canvasBgColor: '#00ff00'
      }
    }
  }
};
export default {
  extension: themeObject,
  name: 'DefaultTheme',
  type: 'theme'
};